export default __webpack_public_path__ + "static/media/group.9e7ecad2.png";